import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateFormData, nextStep, prevStep } from "../../redux/formSlice";

import {
  Box,

  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import PaperA4 from "../../components/icons/PaperA4";
import PaperA3 from "../../components/icons/PaperA3";
import PaperA5 from "../../components/icons/PaperA5";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import StepNavigation from "../../components/StepNavigation";

function PaperSize() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const formData = useSelector((state) => state.form.formData);
  const onSubmit = (data) => {
    dispatch(updateFormData(data));
    dispatch(nextStep());
  };
  const [selectedSize, setSelectedSize] = useState(formData.size); // Track selected time

  const handleRadioChange = (event) => {
    setSelectedSize(event.target.value);
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col items-center w-full"
        sx={{
          gap: 2,
          backgroundColor: "#f9fafb",
          padding: { xs: 2, sm: 3, md: 4 },
          borderRadius: 4,
        }}
      >
        <FormLabel
          component="h2"
          sx={{
            fontSize: "22px",
            fontWeight: "bold",
            textAlign: "left",
            width: "100%",
            pl: 1,
            mb: 2,
            color: "text.primary",
          }}
        >
          {t("Upload.Size")}
        </FormLabel>

        <RadioGroup
          defaultValue={formData.size}
          {...register("size")}
          onChange={handleRadioChange}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
          }}
        >
          {[
            { key: "A4", icon: <PaperA4 />,label: t("Upload.PaperA4") },
            { key: "A5", icon: <PaperA5 />, label: t("Upload.PaperA5") },
            { key: "A3", icon: <PaperA3 />, label: t("Upload.PaperA3") },
          ].map(({ key, icon, label }) => (
            <motion.div
              key={key}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.5  }}
            >
              <FormControlLabel
                value={key}
                control={
                  <Radio
                    icon={icon}
                    checkedIcon={React.cloneElement(icon, {
                      sx: { color: "white" },
                    })}
                  />
                }
                labelPlacement="start"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  borderRadius: 2,
                  px: 2,
                  ml:0,
                  py: 1.5,
                  boxShadow: selectedSize === key ? 3 : 1,
                  border:
                    selectedSize === key
                      ? "2px solid #14b8a6"
                      : "1px solid #e0e0e0",
                  backgroundColor:
                    selectedSize === key ? 'secondary.main' : "background.paper",
                  color: selectedSize === key ? "white" : "text.primary",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    boxShadow: 4,
                    borderColor: selectedSize === key ? "#14b8a6" : "#cfd8dc",
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: "18px",
                    fontWeight: 600,
                  },
                }}
                label={label}
                {...register("size")}
              />
            </motion.div>
          ))}
        </RadioGroup>

        <StepNavigation
          onBack={() => dispatch(prevStep())}
          onContinue={handleSubmit(onSubmit)}
          backLabel={t("Upload.Back")}
          continueLabel={t("Upload.Continue")}
          showBack
          showContinue
          continueDisabled={!selectedSize}
        />
      </Box>
    </>
  );
}

export default PaperSize;
